var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetaGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 2.4,
    width: 11.2,
    height: 11.2,
    rx: 0.6,
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.3999V13.5999",
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.3999V13.5999",
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 10.0001L13.6004 10.0001",
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 5.99988L13.6004 5.99988",
    stroke: "currentColor",
    strokeWidth: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaGrid);
export default __webpack_public_path__ + "static/media/metaGrid.947f04e4.svg";
export { ForwardRef as ReactComponent };